module.exports = __webpack_public_path__ + "static/media/share.b561c163.svg";